import React from "react";
import PropTypes from "prop-types";
import padStart from "lodash/padStart";

import Product from "apps/payment/components/Product";
import PurchaseButton from "apps/payment/components/PurchaseButton";
import ProductSwitcher from "apps/payment/components/ProductSwitcher";
import ProductHeader from "apps/payment/components/ProductHeader";

import Str from "shared/components/Str";

import {
	CREDIT_SCREEN,
	CREDIT_CARD_PAYMENT_PROCESSOR,
	PAYPAL_PAYMENT_PROCESSOR,
} from "shared/payment/constants";

import "./ExistingInfo.scss";

const ExistingInfo = ({
	product,
	productChoices,
	setProduct,
	paymentToken,
	purchase,
	navigateScreen,
	isSuccessful,
	isPurchasing,
	userInfo,
}) => (
	<div className="payment-purchase-existing">
		<span>
			<ProductHeader product={product} />
			<ProductSwitcher
				productChoices={productChoices}
				selectedProduct={product}
				onSwitchProduct={setProduct}
			/>

			<Product
				product={product}
			/>
		</span>

		<form onSubmit={(ev) => {
			ev.preventDefault();
			ev.stopPropagation();

			if (!isSuccessful && !isPurchasing) {
				purchase(paymentToken);
			}
		}}>
			<PurchaseButton
				isSuccessful={isSuccessful}
				isPurchasing={isPurchasing}
				state={userInfo.state}
			>
				<button
					className="payment-purchase-existing-change"
					onClick={() => navigateScreen(CREDIT_SCREEN)}
					type="button"
				>
					{paymentToken.paymentProcessor === PAYPAL_PAYMENT_PROCESSOR &&
						<span>
							<Str>PayPal id</Str>
							{" "}
							<span className="payment-purchase-existing-change-link">
								{paymentToken.pplEmailAddress}
							</span>
						</span>
					}
					{paymentToken.paymentProcessor === CREDIT_CARD_PAYMENT_PROCESSOR &&
						<span>
							<Str>Card ending in</Str>
							{" "}
							<span className="payment-purchase-existing-change-link">
								{padStart(paymentToken.cardNumber, 4, "0")}
							</span>
						</span>
					}
				</button>
			</PurchaseButton>
		</form>
	</div>
);

ExistingInfo.propTypes = {
	product: PropTypes.object,
	paymentToken: PropTypes.shape({
		tokenid: PropTypes.string.isRequired,
		paymentProcessor: PropTypes.string.isRequired,
		pplEmailAddress: PropTypes.string.isRequired,
		cardNumber: PropTypes.string.isRequired,
	}).isRequired,
	userInfo: PropTypes.shape({
		state: PropTypes.string,
	}).isRequired,
	isSuccessful: PropTypes.bool.isRequired,
	isPurchasing: PropTypes.bool.isRequired,
	navigateScreen: PropTypes.func.isRequired,
	purchase: PropTypes.func.isRequired,
	setProduct: PropTypes.func.isRequired,
	productChoices: PropTypes.array,
};

ExistingInfo.defaultProps = {
	product: {},
	productChoices: [],
};

export default ExistingInfo;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ExistingInfo.jsx